import React, { useContext } from "react";

// Material uI imports
import Tooltip from "@material-ui/core/Tooltip";
import HelpIcon from "@material-ui/icons/Help";

// Styling
import "./AddNewClassModals.css";

// global state
import { StateContext } from "../../AppStateContext";

const AddNewPropertyNameInput = ({ propObj, setPropObj }) => {
  // global state
  const state = useContext(StateContext);
  return (
    <div className="__addPropertyNameInput">
      <label
        htmlFor="propertyNameModal"
        className={
          state.theme === "dark"
            ? "__addPropertyNameInputLabelDark "
            : "__addPropertyNameInputLabelLight"
        }
      >
        Name <span>*</span>
        <Tooltip
          placement="right-start"
          title="The name of the property should be descriptive (e.g. title, name, or summary). A property name starts with a lowercase letter, and concatenated words are camelCased (e.g. writtenBy, or publishedBy)."
        >
          <HelpIcon
            style={{
              fontSize: "15px",
              color: state.theme === "dark" ? "#848484" : "#5e5e5e",
              cursor: "pointer",
            }}
          />
        </Tooltip>
      </label>
      <small style={{ color: state.theme === "dark" ? "#e2e9ff" : "#00152b" }}>
        Camel case, starting with lower case letter
      </small>
      <input
        type="text"
        id="propertyNameModal"
        className={
          state.theme === "dark"
            ? "__addPropertyNameInputDark"
            : "__addPropertyNameInputLight"
        }
        value={propObj.name}
        onChange={(e) => setPropObj({ ...propObj, name: e.target.value })}
      />
    </div>
  );
};

export default AddNewPropertyNameInput;
